import {Typography} from "@mui/material";

export const ReleaseNotesContent = () => {


    return {
        title: 'Release Notes ',
        content: (
            <>
                <Typography paragraph sx={{ fontWeight: 'bold' }}>
                    The following changes were deployed to the system on 8/28/2026:
                </Typography>

                <ul>
                    <li>
                        Added From Amount and To Amount to Participant Share Helper screen.
                    </li>

                    <li>
                        Added Gross Proceeds template.
                    </li>

                    <li>
                        Fixed logic for getting Gross Participations amount as cost on Net Deals.
                    </li>
                    <li>
                        Added Tooltip delay between rows in grids.
                    </li>

                    <li>
                        Added refresh button to Contract Detail screen.
                    </li>

                    <li>
                        Fixed bug in Clone Contents and Graft Branch.
                    </li>

                </ul>
                <Typography paragraph sx={{ fontWeight: 'bold' }}>
                    The following changes were deployed to the system on 8/26/2026:
                </Typography>

                <ul>
                    <li>
                        Changed Standard Contract tab to Standard Contracts.
                    </li>

                    <li>
                        Reversed the order of the Standard Contracts list so new templates are at the top.
                    </li>

                    <li>
                        Added External Data icon to Contract Data Point Value grid in Work Queue so users can fly off to the external data records.
                    </li>

                    <li>
                        Added refresh button on the Property dropdown in the Work Queue so the list can be refreshed when new contract models are added on another browser tab.
                    </li>

                    <li>
                        Added drilldown logic to Line Items so related Line Items can parse standard definitions of Grosses and Expenses on a Deal.
                    </li>

                    <li>
                        Added new Net Proceeds template.
                    </li>

                    <li>
                        Added a Calc folder to the list of folders in the Work Queue so the configurations of a calculated period can be seen there.
                    </li>

                    <li>
                        Blocked the generation of contract models if abstract already has a contract model, Deal ID is in use or participant, property and net/gross already exists.
                    </li>

                    <li>
                        Blocked adding guild more than once to a property.
                    </li>

                    <li>
                        Fixed the remaining date fields so data entry works now.
                    </li>
                </ul>
                <Typography paragraph sx={{ fontWeight: 'bold' }}>
                    The following changes were deployed to the system on 8/11/2026:
                </Typography>

                <ul>
                    <li>
                        Blocked Abstracts generating more than once.
                    </li>

                    <li>
                       Blocked abstracts duplicating same contracted party and participant type on same property.
                    </li>

                    <li>
                        Blocked same guild-level contract being added more than once to a property.
                    </li>

                </ul>
                <Typography paragraph sx={{ fontWeight: 'bold' }}>
                    The following changes were deployed to the system on 7/5/2026:
                </Typography>

                <ul>
                    <li>
                        Fixed Helper for filters.
                    </li>

                    <li>
                        Added Group logic for Contract Data Points for Regions.
                    </li>

                    <li>
                        Added Facet level below Aspect for Participations.
                    </li>

                    <li>
                        Revised product contract list in Work Queue.
                    </li>

                    <li>
                        Made label part of Contract Section names bold font in Abstracts.
                    </li>

                    <li>
                        Fixed sequencing issue.
                    </li>

                </ul>
                <Typography paragraph sx={{ fontWeight: 'bold' }}>
                    The following changes were deployed to the system on 6/25/2026:
                </Typography>

                <ul>
                    <li>
                        Abstracts now sort by newest first.
                    </li>

                    <li>
                        Added Helpers to Abstracts.
                    </li>

                    <li>
                        Streamlined auto-generation of Bonuses, Shares, etc.
                    </li>

                    <li>
                        Moved Contract column in Obligation and Expense screens.
                    </li>
                </ul>

                <Typography paragraph sx={{ fontWeight: 'bold' }}>
                    The following changes were deployed to the system on 6/14/2026:
                </Typography>

                <ul>
                    <li>
                        Added new item hierarchy-based gross template to Participations.
                    </li>

                    <li>
                        Added Code tooltip to Data Point screen.
                    </li>

                </ul>
                <Typography paragraph sx={{ fontWeight: 'bold' }}>
                    The following changes were deployed to the system on 6/11/2026:
                </Typography>

                <ul>
                    <li>
                        Added Admin button on the right-hand side of the menu bar.
                        The Admin screen allows users to view and kill jobs that are running.
                    </li>

                </ul>
                <Typography paragraph sx={{ fontWeight: 'bold' }}>
                    The following changes were deployed to the system on 6/8/2026:
                </Typography>

                <ul>
                    <li>
                        Implemented database audits on most tables and functions.
                    </li>


                    <li>
                        Restored the Advance algorithm (contract model builder).
                    </li>

                    <li>
                        Restored contract calculation/test calc functionality.
                    </li>

                    <li>
                        Restored Dashboard populating functionality.
                    </li>

                    <li>
                        Created new Participations configurations for Subject Amount.
                    </li>

                    <li>
                        Created dropdown lists of financial fields that apply codes instead of ids.
                    </li>

                    <li>
                        Cleaned up Participations bonus configurations.
                    </li>

                    <li>
                        Added Combination Trigger bonus configurations for Participations.
                    </li>

                    <li>
                        Added Participations functionality to calculate deal on additional products.
                    </li>

                    <li>
                        Moved production costs as PROD_COST account in the financial table from the product table.
                    </li>

                    <li>
                        Added distribution channel as a column in the financial table.
                    </li>

                    <li>
                        Added formatting to the Contract Section list in Contract Section Cloning Form.
                    </li>

                    <li>
                        Added formatting to the Parent Contract Section list in Contract Section Form.
                    </li>

                    <li>
                        Added Allow Many checkbox to Data Point Form.
                    </li>

                    <li>
                        Formatted Exception Ind in Data Point Value grid.
                    </li>

                    <li>
                        Changed screen header to different color when running app on Local Environment to
                        ensure correct version is modified.
                    </li>

                </ul>
        {/*    </>*/}
        {/*)*/}
        {/*title: 'Release Notes 5/30/2026',*/}
        {/*content: (*/}
        {/*    <>*/}
                <Typography paragraph sx={{ fontWeight: 'bold' }}>
                    The following changes were deployed to the system on 5/30/2026:
                </Typography>

                <ul>
                    <li>
                        A release notes dialogue has been added to the top menu bar.
                    </li>

                    <li>
                        The Info button has been removed, replaced by info dialogues
                        triggered by clicking on page headers.
                    </li>

                    <li>
                        A dialogue has been added to the Contramatic logo to display key
                        details of the application.
                    </li>

                    <li>
                        Expression translations have been fixed so that they generate
                        when a Contract Data Point Value is added/edited that has an expression.
                    </li>

                    <li>
                        The flyoff to the source master contract has been fixed in the following Issuance
                        screens: Calc: Obligation, Calc: Offset, Pay: Fringe.
                    </li>

                    <li>
                        Added Description Tooltips to Destination Folder and Contract Level dropdowns in Contract Data Point Form.
                    </li>

                    <li>
                        Added Description Tooltip to Origin dropdown in Contract Data Point Value Form.
                    </li>

                    <li>
                        Added resequencing to end of contract and contract content functions to reduce sequencing issues.
                    </li>

                    <li>
                        Added contract name to Contract header in Contract Work Queue so the selected contract can be seen
                        when collapsed.
                    </li>

                </ul>
            </>
        )
    };

};

